import { getFileBlob, putFile } from './idbFiles'

function safeJson(resp) {
  return resp
    .json()
    .catch(() => ({}))
    .then((x) => (x && typeof x === 'object' ? x : {}))
}

export async function uploadFileOrFallback(file, uploadUrl, { allowLocalFallback = true } = {}) {
  if (!file) throw new Error('missing file')
  if (!uploadUrl) throw new Error('missing uploadUrl')

  try {
    const formData = new FormData()
    formData.append('file', file)
    const resp = await fetch(uploadUrl, { method: 'POST', body: formData })
    const data = await safeJson(resp)
    if (resp.ok && data?.url) return { url: String(data.url), mode: 'remote' }

    if (!allowLocalFallback) {
      throw new Error(String(data?.error || `upload failed: ${resp.status}`))
    }

    if (String(data?.error || '') === 'not_implemented') {
      const localUrl = await putFile(file, { name: file.name || 'file', type: file.type || '' })
      return { url: localUrl, mode: 'local' }
    }

    throw new Error(String(data?.error || `upload failed: ${resp.status}`))
  } catch (e) {
    if (!allowLocalFallback) throw e
    const localUrl = await putFile(file, { name: file.name || 'file', type: file.type || '' })
    return { url: localUrl, mode: 'local' }
  }
}

export async function fetchBlobFromUrl(url) {
  if (!url) return null
  if (String(url).startsWith('idb:')) {
    return await getFileBlob(url)
  }
  const resp = await fetch(url)
  if (!resp.ok) throw new Error(`fetch failed: ${resp.status}`)
  return await resp.blob()
}

